import React from "react";
import styled from "styled-components";
import lockImg from "../../images/lock.svg";

const StyledWrapper = styled.section`
  background-color: #a4d0954a;
  padding: 42px 25vw 64px;
  margin: 147px 22px 160px 20px;
  border-radius: 60px;
  font-family: Inter;
  color: #213e1b;
  text-align: center;
  letter-spacing: 0em;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    margin: 160px 14px 160px 16px;
    padding: 64px 31px 62px;
  }

  .lock-img-container {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1fdb0063;
    height: 76px;
    width: 76px;
    border-radius: 38px;
    margin-bottom: 16px;
    @media (max-width: 768px) {
      background-color: #6bc75a;
      margin-bottom: 21px;
    }
  }

  .lock-img {
    height: 42px;
    width: 32px;
  }

  .heading {
    font-size: 45px;
    font-weight: 700;
    line-height: 52px;
    letter-spacing: -0.01em;
    margin-bottom: 32px;
    @media (max-width: 768px) {
      margin-bottom: 16px;
      font-size: 32px;
      line-height: 40px;
      letter-spacing: 0em;
    }
  }

  .text {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    width: 500px;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
      width: unset;
    }
  }
`;

const Security = () => {
  return (
    <StyledWrapper>
      <div className="lock-img-container">
        <img src={lockImg} alt="" className="lock-img" />
      </div>
      <div className="heading">
        Your security is our
        <br /> top priority
      </div>
      <div className="text">
        Our stringent data protocols make sure that all your data is fully
        secure and treated with the utmost care.
      </div>
    </StyledWrapper>
  );
};

export default Security;
